module.exports = __webpack_public_path__ + "media/images/icons/vendors/webpic/paperthings-bf84288e1a72b843d6048255e41c060e.webp";